import { render } from "./setting-msg-box.vue?vue&type=template&id=21141e03&scoped=true&ts=true"
import script from "./setting-msg-box.vue?vue&type=script&lang=ts"
export * from "./setting-msg-box.vue?vue&type=script&lang=ts"

import "./setting-msg-box.vue?vue&type=style&index=0&id=21141e03&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21141e03"]])

export default __exports__